"use client";

import { Activity, AudioWaveform, Gauge, Mic as Mic2 } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function TheIronHabitEdge() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: pillarsRef,
    isVisible: pillarsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const featureBlocks = [{
    title: "Cold Storage",
    description: "Pharmaceutical-grade refrigeration to maintain molecular integrity."
  }, {
    title: "Lab Verified",
    description: "Third-party testing ensuring absolute purity and potency."
  }, {
    title: "Batch Traceability",
    description: "Full transparency from raw synthesis to final delivery."
  }];
  const pillars = [{
    icon: Mic2,
    title: "Precision Synthesis",
    description: "Advanced chemical engineering for maximum bioavailability."
  }, {
    icon: AudioWaveform,
    title: "Cold Chain Logistics",
    description: "Temperature-controlled shipping to preserve peptide stability."
  }, {
    icon: Gauge,
    title: "Purity Standards",
    description: "Strict adherence to 99%+ purity benchmarks in every batch."
  }, {
    icon: Activity,
    title: "Performance Data",
    description: "Quantifiable results backed by rigorous analytical testing."
  }];
  return;
}